<script>
import api from '@/helpers/api-rest/api.js';
//import vue2Dropzone from "vue2-dropzone";

export default {
  // components: { vueDropzone: vue2Dropzone },
  props: {
    showTypeModal: Boolean,
    company_type: {type: Object, default: () => {
        return {
            name: '',
            category: '',
            icon: '',
            icon_url: '',
        }
    }} 
  },
  data(){
    return {
      filename: null,
      imageFile: null,
      imageFileName: null,
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 150,
        maxFilesize: 0.5,
        headers: { "My-Awesome-Header": "header value" }
      }
    }
  },
  computed: {
    modalTitle() {
      return this.company_type?.id ? 'Editar Tipo' : 'Añadir Tipo';
    },
    submitButtonText() {
        return this.company_type?.id ? 'Guardar' : 'Añadir Tipo';
    },
    fileInputLabel() {
      return this.imageFile ? this.imageFile.name : 'Selecciona imagen';
    }
  },
  methods: {
    onFileChange(event) {
      this.imageFile = event.target.files[0];
      this.company_type.icon = this.imageFile;
      //console.log(this.company_type.icon);
    },
    createCompanyType() {
      const apiEndpoint = `/api/v1/company-types`; 
      api.post({url:apiEndpoint, data:this.company_type})
        .then(response => {
          const newCompanyType = response.data;
          this.$emit('success', newCompanyType);
          this.$bvModal.hide("ModalCompanyType");
        })
        .catch(error => {
          console.error("Error al crear el tipo:", error);
        });
    },

    updateCompanyType() {
        const formData = new FormData();
        formData.set('icon', this.company_type.icon);
        formData.append('name', this.company_type.name);
        formData.append('category', this.company_type.category);
        //const config = {headers: { 'content-type': 'multipart/form-data' }};

        console.log(this.company_type);

        // const apiEndpoint = `/api/v1/company-types/${this.company_type.id}?_method=PATCH`;
        // api.post({url:apiEndpoint, data:formData, config})
        // .then(response => {
        //     const updatedType = response.data;
        //     this.$emit('success', updatedType);
        //     this.$bvModal.hide("ModalCompanyType");
        // })
        // .catch(error => {
        //     console.error("Error editando tipo:", error);
        // });
    },

    submitForm() {        
        if(this.company_type?.id){
            return this.updateCompanyType();
        }

        return this.createCompanyType();
    },
    cancelForm() {
        this.$bvModal.hide("ModalCompanyType");
        this.$emit('close-modal');
    }
  }
};
</script>

<template>
  <b-modal id="ModalCompanyType" :title="modalTitle" :size="'xl'">
    <template #default="{  }">
      <form @submit.prevent="submitForm" enctype="multipart/form-data">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-xs-12 mb-2">
            <div class="card">
              <div class="card-header text-white bg-primary">Información general</div>
              <div class="card-body">
                <div class="row">
                  <div class="form-group col-md-6 col-xs-12">
                    <label for="name">Nombre:</label>
                    <input v-model="company_type.name" type="text" class="form-control" id="name" required>
                  </div>
                  <div class="form-group col-md-6 col-xs-12">
                    <div class="container">
                      <div class="d-flex justify-content-center align-items-center" style="height: 100px;">
                        <img :src="company_type.icon_url" class="img-fluid" alt="Icono de la empresa" style="width: 50px; height: 50px;">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-6 col-xs-12">
                    <!-- <label for="selectedCompanyType">Categoría:</label> -->
                    <!-- <select v-model="selectedOption" class="form-control">
                      <option value="consumer">Consumidora</option>
                      <option value="production">Productora</option>
                    </select> -->
                    <label for="category">Categoría:</label>
                    <input v-model="company_type.category" type="text" class="form-control" id="category" required>
                  </div>
                  <div class="form-group col-md-6 col-xs-12">
                    <label for="icon">Icono:</label>
                    <div class="custom-file">
                      <input id="inputFileUpload" type="file" name="image" class="custom-file-input" @change="onFileChange" />
                      <label class="custom-file-label" for="inputFileUpload">{{ fileInputLabel }}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </template>

    <template #modal-footer="{  }">
      <b-button variant="primary" @click="submitForm()">{{ submitButtonText }}</b-button>
      <b-button @click="cancelForm()">Cancelar</b-button>
    </template>
  </b-modal>
</template>